// Public surface for `@auctogon/core/api`. Routes / error boundaries import
// from here — never the implementation files directly.
//
// See `.claude/rules/error-handling-chain.md` for the bubble + middleware pattern.

export type { ErrorEnvelope, SuccessEnvelope } from './error-envelope';
export { STANDARD_ERROR_BODY, formatErrorMessage } from './error-envelope';
export { ApiValidationError } from './api-validation-error';
export { AccountBannedError } from './account-banned-error';
export { okEnvelope, errEnvelope } from './envelopes';
export { applyResponseStatusHandlers } from './response-status-handlers';
export type { ResponseStatusHandlers } from './response-status-handlers';
export type { ErrEnvelopeOptions } from './envelopes';
export { verifyTenantScope } from './verify-tenant-scope';
export type {
  TenantIdResolver,
  TenantScopeViolation,
  TenantScopeResult,
  VerifyTenantScopeOptions,
} from './verify-tenant-scope';
export { parseResponse, requestFailedMessage } from './parse-response';
export type { ListPayload } from './list-payload';
// BL-1321 — the one paginated-page envelope for lot list responses, with a
// discriminated `cursor` | `offset` pagination member and server-computed facets.
export type { LotPage, PageMeta } from './lot-page';
// BL-1556 — the repo's one keyset-cursor codec, generic over the sort key.
// `core-bidder`'s `lot-cursor` binds it to `LotSortKey`; `actions-log-service`
// binds it to its own constant. Don't write a third (ADR 044 — Must Consolidate).
export { encodeKeysetCursor, decodeKeysetCursor } from './keyset-cursor';
export type { KeysetCursorPosition } from './keyset-cursor';
// BL-1321 — the route↔registry response tie (ADR 027), shared by both apps.
// Server-only (imports `next/server`); the registry entry it takes is client-safe.
export { respond } from './respond';
